import React, { useEffect } from 'react';
import DOCUMENT_UPLOAD_SETTINGS from '../../../../Contact/WizardClaim/DocumentUpload/settings';
import DocumentComponent from '../../Components/DocumentComponent/DocumentComponent';
import { GoogleTagManager } from '../../../../../helpers';
import {
  TemplateHeaderWithoutBorderStyled as TemplateHeader,
  ContainerStepTwoTitle as Container,
  headerSubtitleHiddenStyled as HeaderText,
} from '../../../FormTemplate/styles/FormTemplateStyled';

const StepTwo = () => {
  useEffect(() => {
    GoogleTagManager.pushToDataLayer({
      event: 'pagina-virtual',
      page: '/ayuda/formulario-recargas/paso-2',
      pagename: 'Formulario Recargas Paso 2',
    });
  }, []);
  return (
    <Container>
      <TemplateHeader>
        <HeaderText>
          <h1>Adjuntar comprobante de pago</h1>
          <p>
            Si la compra fue a través de Webpay encontrarás esta información en
            tu email
          </p>
        </HeaderText>
      </TemplateHeader>
      <DocumentComponent
        label="Seleccionar archivo"
        name="file"
        maxSizeInMB={1}
        formatsAllowed={DOCUMENT_UPLOAD_SETTINGS.FORMAT_ALLOWED}
      />
    </Container>
  );
};

export default StepTwo;
